'use strict';
angular.module('wxRecycleModule', ['wxRecycleRouter']).controller('wxRecycleCtrl', [
    '$scope',
    'editIsLock',
    '$state',
    'trsHttpService',
    'trsspliceString',
    'modalDialog',
    'sensitiveWordCheckService',
    'editingCenterService',
    '$window',
    '$q',
    'trsPrintService',
    'editcenterRightsService',
    'storageListenerService',
    '$stateParams',
    function(
        $scope,
        editIsLock,
        $state,
        trsHttpService,
        trsspliceString,
        modalDialog,
        sensitiveWordCheckService,
        editingCenterService,
        $window,
        $q,
        trsPrintService,
        editcenterRightsService,
        storageListenerService,
        $stateParams
    ) {
        initStatus();
        initData();

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
            initBtnRights();
        }

        /**
         * [initStatus description]初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 10,
            };
            $scope.status = {
                isOnlyMine: false, // 只看我的
                copyCurrPage: 1,
                currChannel: {},
                btnRights: {},
                isSearch: false,
            };
            $scope.data = {
                items: [],
                selectedArray: [],
            };
        }

        /**
         * [showVersionTime description]展示流程版本与操作日志
         * @param  {[str]} MetaDataId [description]
         * @return {[type]}            [description]
         */
        $scope.showVersionTime = function(item) {
            editingCenterService.getVersionTime(item, false);
        };

        /**
         * [initBtnRights description] 初始化权限
         * @return {[type]} [description]
         */
        function initBtnRights() {
            editcenterRightsService.initWeixinListBtn('wechat.recyclemgr', $stateParams.wxchannelid).then(function(rights) {
                $scope.status.btnRights = rights;
            });
        }

        /**
         * [selectAll description:全选]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [selectDoc 单选]
         * @param  {[type]} item [description：单个对象]
         */
        $scope.selectDoc = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };

        /**
         * [restore description] 还原操作
         * @param  {[type]} recId [description]  如果传入代表单个稿件还原，不传代表批量还原
         * @return {[type]}      [description]
         */
        $scope.restore = function(item) {
            $scope.status.isSearch = false;
            modalDialog.confirmModal('还原', '是否确认还原选中的稿件', function() {
                manuscript(item);
            });
        };

        // 还原稿件方法
        function manuscript(item) {
            var params = {
                serviceid: 'mlf_wechatoper',
                methodname: 'restoreMetaDatas',
                ChannelId: $stateParams.wxchannelid,
                ChnlDocIds: trsspliceString.spliceString(item ? [item] : $scope.data.selectedArray, 'CHNLDOCID', ','),
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                modalDialog.alertType('还原成功', '', 'success', false);
                requestData();
            });
        }

        /**
         * [deleteItem description] 删除
         */
        $scope.deleteItems = function(item) {
            $scope.status.isSearch = false;
            modalDialog.confirmModal('删除', '是否从废稿删除', function() {
                deleteItem(item);
            });
        };

        // 删除稿件方法
        function deleteItem(item) {
            var params = {
                serviceid: 'mlf_wechatoper',
                methodname: 'removeMetaDatas',
                ChnlDocIds: trsspliceString.spliceString(item ? [item] : $scope.data.selectedArray, 'CHNLDOCID', ','),
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('删除成功', '', 'success', false, function() {
                    requestData();
                });
            });
        }

        /**
         * [fullTextSearch description] 搜索
         * @return {[type]} [description]
         */
        $scope.fullTextSearch = function($event) {
            if ($event !== undefined && $event.keyCode !== 13) {
                return;
            }
            $scope.status.isSearch = true;
            requestData();
        };

        /**
         * [initData description]刷新列表
         * @return {[type]} [description] null
         */
        function requestData() {
            if (!$scope.status.isSearch) {
                commonReqeust();
            } else {
                searchRequest();
            }
        }

        /**
         * [requestData description]
         * @return {[type]} [description]
         */
        $scope.requestData = function() {
            requestData();
        };

        /**
         * [commonReqeust description]普通列表刷新
         * @return {[type]} [description]
         */
        function commonReqeust() {
            var params = {
                serviceid: 'mlf_wechat',
                methodname: 'queryRecycleDoc',
                PageSize: $scope.page.PAGESIZE,
                CurrPage: $scope.page.CURRPAGE,
                timeType: 0,
                isOnlyMine: $scope.status.isOnlyMine,
                ChannelId: $stateParams.wxchannelid,
                OperTimeStart: $scope.status.fromdate,
                OperTimeEnd: $scope.status.untildate,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                var ListItems = data.DATA;
                $scope.data.items = ListItems;
                $scope.data.selectedArray = [];
                $scope.page = data.PAGER;
                // storageListenerService.previewPageTurningStorage($scope.data.items, "METADATAID,CHNLDOCID", "weixinPreview");
            });
        }

        /**
         * [searchRequest description]搜索情况下刷新列表
         * @return {[type]} [description]
         */
        function searchRequest() {
            var params = {
                serviceid: 'mlf_hybasesearch',
                methodname: 'queryForWeChatRecycleDoc',
                searchParams: JSON.stringify({
                    PAGESIZE: $scope.page.PAGESIZE,
                    PAGEINDEX: $scope.page.CURRPAGE,
                    searchFields: [
                        {
                            searchField: '',
                            keywords: $scope.keywords,
                        }, // 搜索词
                        {
                            searchField: 'timeType',
                            keywords: !$scope.status.untildate ? '' : $scope.status.fromdate + ',' + $scope.status.untildate,
                        }, // 时间,如果没有选择时间传空
                        {
                            searchField: 'isOnlyMine',
                            keywords: $scope.status.isOnlyMine,
                        }, // 是否只看我的
                        {
                            searchField: 'channelid',
                            keywords: $stateParams.wxchannelid,
                        },
                        {
                            searchField: '_sort',
                            keywords: 'time',
                        }, // 后端规定的参数
                    ],
                }),
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                var ListItems = data.DATA;
                $scope.data.items = ListItems;
                $scope.page = data.PAGER;
            });
        }

        /**
         * [isOnlyMine description]只看我的
         * @return {Boolean} [description] null
         */
        $scope.isOnlyMine = function() {
            $scope.page.CURRPAGE = '1';
            $scope.status.isOnlyMine = !$scope.status.isOnlyMine;
            requestData();
        };

        /**
         * [clearTrash description] 清空回收站
         */
        $scope.clearTrash = function() {
            $scope.status.isSearch = false;
            modalDialog.confirmModal('清空回收站', '是否确认清空回收站', function() {
                trash();
            });
        };

        function trash() {
            var params = {
                serviceid: 'mlf_wechatoper',
                methodname: 'removeChnlMetaDatas',
                ChannelId: $stateParams.wxchannelid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('清空回收站成功', '', 'success', false, function() {
                    requestData();
                });
            });
        }
    },
]);
